import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-delete-document',
  standalone:true,
  imports:[CommonModule, MatButtonModule, MatIconModule],
  template: `
  <div class="app-delete-document" style="margin-bottom: 8px;">
    <button mat-icon-button (click)="onClick()">
      <mat-icon>delete</mat-icon>
    </button>
  </div>
  `
})
export class DeleteDocumentComponent {

  _data: any;

  @Input() set data(data: any) {
    this._data = data;
  }

  @Output() action = new EventEmitter<boolean>();

  onClick(): void {
    this.action.emit(this._data);
  }
}
